import brand from '@helpers/brand';
import { cssVar, setCssVar } from '@helpers/cssVar';
import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import { ReactComponent as SvgChevron } from '@img/icons/chevron-right.svg';
import HeadingStyles from '@stories/Components/Global/Typography/Heading.styles';
import styled from 'styled-components';
const Container = styled.article `
  ${setCssVar('accentColor', brand.hta.greenDark)};
  ${setCssVar('bgColor', brand.hta.greenLight)};
  ${setCssVar('accentColor2', brand.hta.green)};
  ${setCssVar('fgColor', brand.black)};
  display: flex;
  flex: 1 1 auto;

  &[data-theme='dark'] {
    ${setCssVar('accentColor', brand.white)};
    ${setCssVar('bgColor', brand.htaRebrand.green)};
    ${setCssVar('fgColor', brand.white)};
  }

  .theme-apl & {
    ${setCssVar('bgColor', brand.apl.greenLight)};
    ${setCssVar('accentColor', brand.black)};

    &[data-theme='dark'] {
      ${setCssVar('accentColor', brand.white)};
      ${setCssVar('bgColor', brand.apl.green)};
      ${setCssVar('fgColor', brand.white)};
    }
  }

  .theme-hh & {
    ${setCssVar('bgColor', brand.white)};
    ${setCssVar('accentColor', brand.grey)};

    &[data-theme='dark'] {
      ${setCssVar('accentColor', brand.white)};
      ${setCssVar('bgColor', brand.hortHouse.greenDark)};
      ${setCssVar('fgColor', brand.white)};
    }
  }
`;
const Chevron = styled(SvgChevron) `
  position: relative;
  height: 12px;
  width: 7px;
  left: 10px;
  transition: left ease-out 0.5s;
`;
const Link = styled.a `
  display: flex;
  flex: 1 1 auto;
  border-radius: 11px;
  color: currentColor;
  flex-direction: column;
  overflow: hidden;
  text-decoration: none;
  transition: transform 0.15s ease-out;

  &:focus,
  &:hover {
    transform: translateY(-8px);

    .theme-apl & {
      ${Chevron} {
        left: 17px;
      }
    }
  }
`;
const ImageWrapper = styled.div `
  position: relative;
  height: 0;
  overflow: hidden;
  padding-bottom: ${(198 / 434) * 100}%;
  background: ${cssVar('accentColor2')};

  [data-theme='dark'] & {
    padding-bottom: ${(321 / 526) * 100}%;
  }

  @media ${until(Device.Tablet)} {
    padding-bottom: ${(96 / 164) * 100}%;

    [data-theme='dark'] & {
      padding-bottom: ${(167 / 269) * 100}%;
    }
  }
`;
const Image = styled.img `
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  transform: scale(1);
  transition: transform ease-out 1s;
  width: 100%;

  ${Link}:focus &,
  ${Link}:hover & {
    transform: scale(1.1);
  }
`;
const ContentWrapper = styled.div `
  display: flex;
  background: ${cssVar('bgColor')};
  flex: 1 1 auto;
  flex-direction: column;
  padding: 16px 20px;
`;
const Title = styled.h3 `
  ${HeadingStyles.H5Styles};

  [data-theme='dark'] & {
    ${fonts.sourceSansPro.bold}
    color: ${cssVar('fgColor')};
    margin-bottom: 0;
    line-height: 30px;
    font-size: 20px;

    @media ${from(Device.Tablet)} {
      font-size: 30px;
      line-height: 38px;
      margin-bottom: 5px;
    }
  }

  @media ${from(Device.Tablet)} {
    font-size: 16px;
    line-height: 18px;
  }

  @media ${from(Device.DesktopMedium)} {
    font-size: 30px;
    line-height: 38px;
    margin-bottom: 16px;
  }
`;
const Content = styled.p `
  ${fonts.sourceSansPro.regular};
  line-height: 26px;

  [data-theme='dark'] & {
    color: ${cssVar('fgColor')};
    font-size: 18px;
    line-height: 28px;
    margin-bottom: 14px;
    display: block;

    @media ${from(Device.TabletLarge)}
    {
      font-size: 18px;
    }

    @media ${from(Device.DesktopMedium)}
    {
      font-size: 24px;
      line-height: 36px;
      margin-bottom: 20px;
    }

    @media ${from(Device.DesktopLarge)}
    {
      font-size: 24px;
    }
  }

  @media ${until(Device.TabletLarge)} {
    display: none;
  }

  @media ${from(Device.TabletLarge)}
  {
    font-size: 14px;
  }

  @media ${from(Device.DesktopMedium)}
  {
    font-size: 16px;
  }

  @media ${from(Device.DesktopLarge)}
  {
    font-size: 16px;
  }
`;
const Cta = styled.span `
  display: block;
  color: ${cssVar('accentColor')};
  ${fonts.sourceSansPro.semiBold};
  font-size: 22px;
  line-height: 32px;
  margin-top: auto;
  text-underline-position: under;

  [data-theme='dark'] & {
    ${fonts.sourceSansPro.bold};

    @media ${until(Device.DesktopMedium)} {
      font-size: 20px;
    }
  }

  @media ${until(Device.Tablet)} {
    font-size: 16px;
    line-height: 26px;
  }

  @media ${until(Device.DesktopMedium)}
  {
    font-size: 16px;
    line-height: 16px
  }

  ${Link}:focus &,
  ${Link}:hover & {
    text-decoration: underline;
  }
`;
export default {
    Container,
    Content,
    ContentWrapper,
    Cta,
    Image,
    ImageWrapper,
    Link,
    Title,
    Chevron,
};
